<footer class="footer ">
 
    <div class="container-fluid">
        <div class="text-center">
            Copyright &copy; PackPlan LogSoft Software Ltd.2005-{{ currentDate | date: 'yyyy' }}, All rights reserved.
        </div>
    </div>
</footer>
